import { createFileRoute } from "@tanstack/react-router";
import { BillingPlans } from "@/components/billing/billing-plans";
import { buildMetaTags } from "@/lib/seo/meta";

export const Route = createFileRoute("/_dashboard/billing")({
	head: () => {
		const meta = buildMetaTags({
			title: "Pricing",
			description: "Compare plans and manage your subscription.",
			noIndex: true,
			noFollow: true,
		});

		return { meta };
	},

	component: () => <BillingPlans variant="dashboard" />,
});
